module.exports = __webpack_public_path__ + "img/TOP_footer.e4626a59.png";